export const EmptyCompany = {
    company_ID: undefined,
    company_Name: '',
    company_City: 0,
    city: {
        city_ID: 0,
        city_Name: ''
    },
    city_Name: '',
    company_Zip: '',
    company_Status: true,
    company_Address: '',
    user_Added_by: 0,
    company_Domain: "",
    req_From_Other_Company: false,
    req_Company_ID: null,
    send_From_Title: "",
    allocate_By_Team: false,
    allocation_Count: 0
}